<template>
  <div>
    <title-bar title="单位编辑">
      <el-button type="primary" @click="save()" :loading="loading">保存</el-button>
      <el-button type="default" @click="cancel()">取消</el-button>
    </title-bar>
    <div class="page-body">
      <el-form ref="editForm" :model="company" label-width="80px" :rules="validateRules"
               style="width: 800px;margin:auto">
        <el-form-item label="单位名称" prop="compName">
          <el-input v-model="company.compName" clearable placeholder="请输入单位名称模糊查询"></el-input>
        </el-form-item>
        <el-form-item label="单位类型" prop="compType">
          <code-select v-model="company.compType" code-type="COMP_TYPE"></code-select>
        </el-form-item>
        <el-form-item label="单位层级" prop="compLevel">
          <code-select v-model="company.compLevel" code-type="COMP_LEVEL"></code-select>
        </el-form-item>
        <el-form-item label="停运日期" prop="stopDay">
          <code-select code-type="WEEKDAY" v-model="company.stopDay"></code-select>
        </el-form-item>
        <el-form-item label="是否启用" prop="valid">
          <el-switch v-model="company.valid"></el-switch>
        </el-form-item>
      </el-form>
      <div class="button-container">
        <el-button type="primary" @click="save()" :loading="loading">保存</el-button>
        <el-button type="default" @click="cancel()">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import TitleBar from "@/components/base/TitleBar";
import TablePagination from "@/components/base/TablePagination";
import BaseVue from "@/components/base/BaseVue";
import CodeSelect from "@/components/base/CodeSelect";
export default {
  name: 'CompanyEdit',
  components: {CodeSelect, TablePagination, TitleBar},
  extends: BaseVue,
  data() {
    return {
      editing: false,
      company: {
        compName: '',
        compType: '',
        compLevel: '',
        stopDay: null,
        valid: true
      },
      records: [],
      validateRules: {
        compName: [{required:true, message:'单位名称不能为空', trigger: 'blur'}],
        compType: [{required:true, message:'单位类型不能为空', trigger: 'change'}],
        compLevel: [{required:true, message:'单位层级不能为空', trigger: 'change'}]
      }
    }
  },
  created() {
    console.log(this.$route)
    let compId = this.$route.query.compId;
    if(compId) {
      this.loading = true;
      this.postForm("/company/getById?compId="+compId,null,true).then(dr=>{
        this.company = dr.bean;
      }).finally(()=>{
        this.loading = false;
      });
    }
  },
  methods: {
    save(){
      this.$refs.editForm.validate((yes)=>{
        if(yes){
          this.loading = true;
          this.postForm("/company/saveCompany", this.company, true).then(dr => {
            this.$router.back();
          }).finally(()=>{
            this.loading = false;
          });
        }
      });
    },
    cancel(){
      this.$router.back();
    }
  }
}
</script>

<style scoped>

</style>